import React from "react";
import { object } from "prop-types";

import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";
import ComponentContainer from "../../layouts/component-container";

import { getSlotId } from "../../utils/utils";

import "./WidgetOrAdvertisement.m.css";

const WidgetOrAdvertisement = ({ collection }) => {
  if (!collection) return null;

  const {
    widget_url: widgetUrl = "",
    ad_name: adName,
    height_for_desktop: desktopHeight,
    height_for_tab: tabHeight,
    height_for_mobile: mobileHeight,
    full_width: fullWidth,
  } = collection["associated-metadata"] || {};

  const iframeHeights = {
    "--widget-frame-desktop-height": `${desktopHeight || 250}px`,
    "--widget-frame-tab-height": `${tabHeight || 250}px`,
    "--widget-frame-mobile-height": `${mobileHeight || 250}px`,
  };

  return (
    <ComponentContainer styleName={`base ${fullWidth ? "full-width" : ""}`} collection={collection} isTitle={false}>
      {adName ? (
        <DfpContainer>
          <div className="special-ads adsBox">
            <DfpComponent
              type={adName}
              adsText={true}
              slotId={getSlotId(adName, collection?.slug, "WidgetOrAdvertisement")}
              collectionSlug={collection?.slug}
              layoutName="WidgetOrAdvertisement"
            />
          </div>
        </DfpContainer>
      ) : widgetUrl ? (
        <iframe
          title="Widget or advertisement component"
          style={iframeHeights}
          styleName="widget-frame"
          src={widgetUrl}
          width="100%"
        ></iframe>
      ) : null}
    </ComponentContainer>
  );
};

WidgetOrAdvertisement.propTypes = {
  collection: object,
};

WidgetOrAdvertisement.storyLimit = 1;

export default WidgetOrAdvertisement;
